import React from "react"
import { Button, Card, Col, ListGroup, Row } from "react-bootstrap"
import withHooks from "../../Common/jsx/WithHooks"
import { ucFirst } from "../../Common/js/generic_functions"
import Badge from "react-bootstrap/Badge"
import Stack from "react-bootstrap/Stack"

class QuestionNumSuiteMcq extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {
      isReadyToRender: true,
      displayJustification: false,
    }

    this.dMgr.debug("init_state:", this.state)

    this.checkAnswer = this.checkAnswer.bind(this)
    this.displayJustification = this.displayJustification.bind(this)
  }

  componentDidMount() {}

  checkAnswer(responseChoice) {
    if (!this.props.chosenAnswer && !this.props.answerGiven) {
      this.dMgr.debug("checkAnswer:", responseChoice)
      this.props.setChosenAnswer(responseChoice)

      if (responseChoice.isCorrect) {
        this.props.updatePlayScore(1)
      } else {
        this.props.updatePlayScore(-1)
      }
    }
  }

  displayJustification() {
    this.dMgr.debug("displayJustification:")
    this.setState({ displayJustification: true })
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <Row className="margin-top-15 margin-bottom-10">
        <Col md={3}></Col>
        <Col md={6}>
          <Card>
            <Card.Body className="bg-dark text-white text-center">
              <div className="font-size-11">
                {this.props.t("entity.question")} #{this.props.currentQuestion.id} - {this.props.currentQuestion.questionType["name" + ucFirst(this.props.i18n.resolvedLanguage)]}
              </div>
              <div className="margin-top-30 margin-bottom-10 font-weight-bold">{this.props.currentQuestion.questionType["commonStatement" + ucFirst(this.props.i18n.resolvedLanguage)]}</div>

              {/* statement */}
              <Stack className="justify-content-center margin-bottom-10" direction="horizontal" gap={3}>
                {this.props.currentQuestion["statement" + ucFirst(this.props.i18n.resolvedLanguage)].split("|").map((statement, index) => {
                  let background = "black"
                  let text = "white"
                  if (statement === "?") {
                    background = "warning"
                    text = "black"
                  }
                  return (
                    <Badge key={"statement_" + this.props.currentQuestion.id + "_" + index} bg={background} className={"text-" + text}>
                      {statement}
                    </Badge>
                  )
                })}
              </Stack>

              {/* possible responses */}
              <ListGroup data-bs-theme="dark" className="margin-top-15 width-300 display-inline-flex">
                {this.props.currentQuestion.responseChoices.map((responseChoice) => {
                  let variant = "black"
                  let textColor = "white"
                  if ((this.props.chosenAnswer || this.props.answerGiven) && (responseChoice.id === this.props.chosenAnswer.id || responseChoice.isCorrect)) {
                    if (responseChoice.id === this.props.chosenAnswer.id && responseChoice.isCorrect) {
                      variant = "success"
                    } else if ((responseChoice.id !== this.props.chosenAnswer.id && responseChoice.isCorrect) || (responseChoice.isCorrect && this.props.answerGiven)) {
                      variant = "warning"
                      textColor = "black"
                    } else {
                      variant = "danger"
                    }
                  } else if (this.props.chosenAnswer || this.props.answerGiven) {
                    variant = ""
                  }
                  responseChoice["justification" + ucFirst(this.props.i18n.resolvedLanguage)].split("|")

                  // justification BUTTON
                  let buttonShowJustification = ""
                  if ((this.props.chosenAnswer || this.props.answerGiven) && !this.state.displayJustification && responseChoice.isCorrect) {
                    buttonShowJustification = (
                      <>
                        <br />
                        <Button
                          className="button-color1 margin-top-8"
                          size="sm"
                          onClick={() => {
                            this.setState({ displayJustification: true })
                          }}
                        >
                          {this.props.t("app.justification")}
                        </Button>
                      </>
                    )
                  }

                  // justification
                  let justification = ""
                  if (this.state.displayJustification && responseChoice.isCorrect) {
                    justification = (
                      <>
                        <br />
                        <br />
                        {responseChoice["justification" + ucFirst(this.props.i18n.resolvedLanguage)].split("|").map((responseElement, index) => {
                          if (responseElement === "") {
                            responseElement = <br />
                          }

                          return <div key={"responseElement" + index}>{responseElement}</div>
                        })}
                      </>
                    )
                  }

                  return (
                    <ListGroup.Item key={"responseChoice" + responseChoice.id} action={!this.props.chosenAnswer && !this.props.answerGiven} onClick={() => this.checkAnswer(responseChoice)}>
                      <Badge bg={variant} className={"text-" + textColor}>
                        {responseChoice["response" + ucFirst(this.props.i18n.resolvedLanguage)]}
                      </Badge>
                      {buttonShowJustification}
                      {justification}
                    </ListGroup.Item>
                  )
                })}
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(QuestionNumSuiteMcq)
